import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import AutoComplete from "../../fields/AutoComplete";

import { TextField, InputAdornment, CircularProgress, MenuItem, Avatar, ListItemText } from "@material-ui/core";
import blankVenueProfile from "../../../img/venue.svg";
import image from "../../../helper/image";

const PAGE_SIZE = 20;

@inject("venueStore")
@observer
class SearchVenueField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            open: false,
            loading: false,
            visibleSuggestionCount: PAGE_SIZE
        };
        this.searchRequestId = 0;
        this.isUnmounted = false;
    }

    componentWillUnmount() {
        this.isUnmounted = true;
        this.searchRequestId += 1;
        clearTimeout(this.requestTimer);
    }

    handleMenuScroll = event => {
        const { suggestions, visibleSuggestionCount } = this.state;
        const menu = event.currentTarget;
        const isNearBottom = menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 24;

        if (isNearBottom && visibleSuggestionCount < suggestions.length) {
            this.setState({
                visibleSuggestionCount: Math.min(visibleSuggestionCount + PAGE_SIZE, suggestions.length)
            });
        }
    };

    renderMenu = children => {
        const { menuStyle } = this.props;
        return (
            <div
                className="menu"
                onScroll={this.handleMenuScroll}
                style={menuStyle ? menuStyle : { position: "absolute", zIndex: "9999", width: "100%", maxHeight: "300px", overflowY: "auto" }}
            >
                {children}
            </div>
        );
    };

    renderInput = props => {
        const { ref, ...rest } = props;

        return (
            <TextField
                {...rest}
                fullWidth
                inputRef={ref}
                InputProps={{
                    endAdornment: this.state.loading ? (
                        <InputAdornment position="start">
                            {" "}
                            <CircularProgress size={30} />
                        </InputAdornment>
                    ) : (
                        ""
                    )
                }}
            />
        );
    };

    renderItem = (item, isHighlighted) => {
        return (
            <MenuItem
                key={item.id ? item.id : item.fullName}
                selected={isHighlighted}
                component="div"
                style={{
                    zIndex: 9999,
                    backgroundColor: isHighlighted ? "#ff0c9c" : "#ffffff"
                }}
            >
                <Avatar alt={item.venueName} src={image.getProfileImage(item)} />
                <ListItemText primary={item.venueName} />
            </MenuItem>
        );
    };

    getItemValue = item => {
        return item.venueName;
    };

    handleSearch = value => {
        const requestId = ++this.searchRequestId;

        this.setState(
            {
                ...this.state,
                loading: true,
                suggestions: [],
                visibleSuggestionCount: PAGE_SIZE
            },
            () => {
                this.props.venueStore.searchVenueAndIndependentVenue(value).then(
                    response => {
                        if (this.isUnmounted || requestId !== this.searchRequestId) {
                            return;
                        }

                        this.setState({
                            ...this.state,
                            loading: false,
                            suggestions: response || [],
                            visibleSuggestionCount: PAGE_SIZE
                        });
                    },
                    () => {
                        if (this.isUnmounted || requestId !== this.searchRequestId) {
                            return;
                        }

                        this.setState({
                            ...this.state,
                            loading: false,
                            suggestions: [],
                            visibleSuggestionCount: PAGE_SIZE
                        });
                    }
                );
            }
        );
    };

    handleChange = (e, value) => {
        clearTimeout(this.requestTimer);
        this.searchRequestId += 1;

        this.setState({
            ...this.state,
            value,
            open: false,
            suggestions: value.length > 3 ? this.state.suggestions : [],
            visibleSuggestionCount: PAGE_SIZE
        });

        this.props.handleValueChange(value);

        if (value.length > 3) {
            this.requestTimer = setTimeout(() => this.handleSearch(value), 500);
            this.setState({ value, open: true });
        }
    };

    handleSelect = (value, item) => {
        this.setState({
            open: false
        });

        this.props.handleSelect(item);
    };

    render() {
        const { suggestions, open, visibleSuggestionCount } = this.state;
        const { value, height, id, placeholder, error, helperText } = this.props;
        return (
            <AutoComplete
                wrapperHeight={height}
                placeholder={placeholder}
                id={id ? id : "venue-search"}
                error={error}
                helperText={helperText}
                open={open}
                value={value}
                items={suggestions.slice(0, visibleSuggestionCount)}
                getItemValue={this.getItemValue}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                renderInput={this.renderInput}
                renderMenu={this.renderMenu}
                renderItem={this.renderItem}
            />
            
        );
    }
}

export default SearchVenueField;
